import { fetchUtils } from "react-admin";
import crudProvider from '../ra-data-nestjsx-crud';

export const fetchJson = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json', "Content-Type": "application/json" });
    }
    options.headers = new Headers({ Accept: 'application/json', "Content-Type": "application/json" });
    // options.headers.set('Authorization', "Bearer " + JSON.parse(localStorage.getItem('token')));
    const  token  = JSON.parse(localStorage.getItem("token"));
    options.headers.set("Authorization", `Bearer ${token}`);
    return fetchUtils.fetchJson(url, options)
}
export const dataProvider = crudProvider(process.env.REACT_APP_URL + `/admin`, fetchJson);
// export const dataProvider = crudProvider(`https://api.mahsool.sd/admin`, fetchJson);